import { render, staticRenderFns } from "./PaySuccessTip.vue?vue&type=template&id=070c7394&scoped=true&"
import script from "./PaySuccessTip.vue?vue&type=script&lang=js&"
export * from "./PaySuccessTip.vue?vue&type=script&lang=js&"
import style0 from "./PaySuccessTip.vue?vue&type=style&index=0&id=070c7394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c7394",
  null
  
)

export default component.exports